import { CategoriesParser } from '@services/http/parsers/categories-response.parser';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetCategoriesRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'categories';

  /**
   * @inheritdoc
   */
  responseParser = new CategoriesParser();

  cache = true;

  /**
   * @inheritdoc
   */
  constructor(id, language) {
    super(language);
    this.relativePath = `${this.relativePath}/${id}`;
  }

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
